import React from "react";
import styled from "styled-components";

const Button = styled.button`
background-color: #ffffff;
color: black;
padding: 10px;
border-radius: 10px;
border-color: transparent;
cursor: pointer;
&:hover {
  background-color: #006699;
  transition-property: background-color, color;
  transition-duration: 0.4s;
  transition-delay: 0.2s;
  transition-timing-function: easin-out;
  transtion: transform;
  color: white;
}
`;

export default function ({ onClick, text, href, style }) {
  return <Button style={style} onClick={onClick}><a style={style} href={href}>{text}</a></Button>;
}
